<div mat-dialog-content>{{ data.question }}</div>
<div class="dialog-actions-right" mat-dialog-actions>
  <button mat-button mat-dialog-close>No</button>
  <button cdkFocusInitial color="warn" mat-dialog-close mat-raised-button (click)="clickedOK()">Yes</button>
</div>

<style>
  .dialog-actions-right {
    display: flex;
    justify-content: flex-end;
  }
</style>
